/* eslint-disable import/no-cycle */
import React from 'react';

import { Button } from 'components';
import { useModalVehicle } from 'domains/landing-autos/hooks/use-modal-vehicle';
import { SelectSearch } from 'components/select-search/select-search';
import { IOption } from 'domains/quotation/constants/information';
import SpinnerCar from 'components/spinner/spinner-car/spinner-car';
import Modal from 'components/modal/modal';
import './new-vehicle-modal.scss';
import VehicleIcon from 'components/icons/vehicle';

interface Props {
  isOpen: any;
  isEdit?: boolean;
  handleClose: any;
  fieldsNewVehicle?: any;
  setFieldNewVehicle?: any;
}

const NewVehicleModal: React.FC<Props> = ({
  handleClose,
  isOpen,
  isEdit = false,
  fieldsNewVehicle,
  setFieldNewVehicle,
}: Props) => {
  const {
    brands,
    models,
    years,
    fields,
    handleBrandChage,
    hanldeOnChange,
    handleBtnSave,
    formValid,
    hasPlate,
    provinces,
    closeModal,
    spinner,
    error,
    sumInsured,
  } = useModalVehicle({
    handleClose,
    isOpen,
    isEdit,
    fields: fieldsNewVehicle,
    setField: setFieldNewVehicle,
  });

  return (
    <div className="new-vehicle-modal">
      <Modal
        onClose={closeModal}
        hasClose={false}
        isOpen={isOpen}
        className="new-vehicle-modal"
      >
        <div>
          <div className="new-vehicle-modal__form-content">
            <div className="new-vehicle-modal__header">
              <VehicleIcon />
              <h3 className="new-vehicle-modal__title">Sobre tu vehículo</h3>
            </div>
            {error && (
              <p className="new-vehicle-modal-error">
                No podemos cotizar, no se pudo calcular la suma asegurada de tu
                vehículo
              </p>
            )}
            <div className="new-vehicle-modal__form">
              <div className="form-group">
                <SelectSearch
                  id="brand"
                  label="Marca"
                  className="w-100"
                  elements={brands}
                  onChange={handleBrandChage}
                  value={fields.brandCode}
                  required
                  dataLayer
                  valueDatalayer="Sobre tu vehículo:"
                />
                <SelectSearch
                  id="model"
                  label="Modelo"
                  className="w-100"
                  elements={models}
                  onChange={(item: IOption) =>
                    hanldeOnChange(item.value, 'modelCode')
                  }
                  value={fields.modelCode}
                  dataLayer
                  required
                  valueDatalayer="Sobre tu vehículo:"
                />
                <SelectSearch
                  id="year"
                  label="Año de Fabricación"
                  className="w-100"
                  elements={years}
                  onChange={(item: IOption) =>
                    hanldeOnChange(item.value, 'year')
                  }
                  value={fields.year}
                  required
                  dataLayer
                  valueDatalayer="Sobre tu vehículo:"
                  editable={false}
                />
              </div>
              {!hasPlate && (
                <SelectSearch
                  id="edit-province"
                  label="Lugar de circulación"
                  className="w-100"
                  elements={provinces}
                  onChange={(item: IOption) =>
                    hanldeOnChange(item.value, 'province')
                  }
                  value={fields.province}
                  required
                  dataLayer
                  valueDatalayer="Sobre tu vehículo:"
                />
              )}
            </div>
            <div className="new-vehicle-modal__button-container">
              <Button
                label="Continuar"
                className="mt-40"
                onClick={handleBtnSave}
                disabled={!formValid || !sumInsured}
              />
            </div>
          </div>
          <SpinnerCar
            show={spinner}
            title="Un momento por favor"
            text="Estamos actualizando los datos de tu plan"
          />
        </div>
      </Modal>
    </div>
  );
};

NewVehicleModal.defaultProps = {
  isEdit: false,
};

export default NewVehicleModal;
